export const TIPO_TEMPLATE_EMAIL = {
    
    CADASTRO_CANDIDATO: "CADASTRO_CANDIDATO",
    EDICAO_CADASTRO_CANDIDATO: "EDICAO_CADASTRO_CANDIDATO",
    INSCRICAO: "INSCRICAO",
    INSCRICAO_MEDICINA: "INSCRICAO_MEDICINA",
    RESULTADO_GERAL_MEDICINA: "RESULTADO_GERAL_MEDICINA", 
    RESULTADO_CLASSIFICACAO: "RESULTADO_CLASSIFICACAO", 
    RESULTADO_CLASSIFICACAO_MEDICINA: "RESULTADO_CLASSIFICACAO_MEDICINA", 
	ALTERAR_SENHA: "ALTERAR_SENHA",
	LEMBRETE_AGENDAR_PROVA: "LEMBRETE_AGENDAR_PROVA",
	CONVOCACAO_PROVA_CURSOS_SEMESTRAIS: "CONVOCACAO_PROVA_CURSOS_SEMESTRAIS",
    CONVOCACAO_PROVA_MEDICINA: "CONVOCACAO_PROVA_MEDICINA",
    ENVIO_CARTAO_CONFIRMACAO: "ENVIO_CARTAO_CONFIRMACAO",
    ENVIO_CODIGO_VALIDACAO_EMAIL: "ENVIO_CODIGO_VALIDACAO_EMAIL",
    PENDECIAS_DOCUMENTACAO_MATRICULA: "PENDECIAS_DOCUMENTACAO_MATRICULA",
    PENDECIAS_DOCUMENTACAO_INSCRICAO: "PENDECIAS_DOCUMENTACAO_INSCRICAO",
    BENEFICIO_INSCRICAO_RAPIDA: "BENEFICIO_INSCRICAO_RAPIDA",
    ENVIO_BOLETO_PAGAMENTO_INSCRICAO: "ENVIO_BOLETO_PAGAMENTO_INSCRICAO",
    
}